<template>
    <div class="second-row__text-input">
        <v-autocomplete
                v-if="autocomplete"
                v-model="input"
                :search-input.sync="search"
                hide-no-data
                hide-selected
                :loading="isLoading"
                class="text-center input-chip"
                @keypress.native.enter="saveInputData"
                label="Type searching phrase here"
                :items="aclist"
                item-color="red"
                solo>
        </v-autocomplete>
        <v-text-field
                v-else
                autocomplete="off"
                v-model="search"
                class="text-center input-chip"
                @keypress.native.enter="saveInputData"
                label="Type searching phrase here"
                solo>
        </v-text-field>
        <div :key="index" v-for="(item, index) in values">
            <v-chip v-if="index < 2"
                    close slot="append"
                    close-icon="mdi-close"
                    class="text-center input-chip"
                    :key="index"
                    @click:close="removeChip(index)">
                <span>{{ item }}</span>
            </v-chip>
            <div v-if="index === 2" class="text--primary caption chip__others-message">
                (+{{values.length - 2}} others)
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        name: "InputText",
        props: ['value', 'autocomplete'],
        data: () => ({
            input: '',
            search: '',
            aclist: [],
            values: [],
            isLoading: false
        }),
        methods: {
            saveInputData: function () {
                if (this.search) {
                    this.values.unshift(this.search);
                    this.input = '';
                    this.search = '';
                }
            },
            removeChip(id) {
                this.values = this.values.filter((chip, index) => index !== id);
            }
        },
        mounted() {
            this.values = this.value ? this.value : [];
        },
        watch: {
            values: {
                handler: function (val, oldVal) {
                    if (val && val.length > 0) {
                        this.$emit('input', val)
                    }
                },
                deep: true
            },
            value: {
                handler: function (val, oldVal) {
                    this.values = (val !== null) ? val:[]
                },
                deep: true
            },
            search (val, oldVal) {
                if (val && val.length >= 3 && typeof this.autocomplete === 'function') {
                    this.isLoading = true
                    return this.autocomplete(val)
                        .then(r => { 
                            this.aclist = r
                            this.isLoading = false
                        }).catch(_ => {
                            this.aclist = []
                            this.isLoading = false 
                        })
                } else {
                    this.aclist = []
                }
            }
        }
    }
</script>

<style scoped>

</style>
